// extracted by mini-css-extract-plugin
module.exports = {"container":"news_container__3Hh_C","date":"news_date__1Kl0x","content":"news_content__Wm7dF","teploinform":"news_teploinform__3wcR2"};